<script setup lang="js">

import ContextWhile from "@/components/ContextWhile.vue";
import ContextTitle from "@/components/ContextTitle.vue";
import {ref} from "vue";
import CompanyTitle from "@/components/CompanyTitle.vue";
import SubButton from "@/components/SubButton.vue";
import {ElForm, ElMessage} from "element-plus";
import router from "@/router";
import axios from "axios";

const datas=ref({
  role:'',//角色
  core:[],//核心资源
  digitize:[],
  userName:'',
  phone:'',
  email:'',

})

const formRef = ref(null);
const rules = ref({
  role: [
    { required: true, message: '请选择你的角色', trigger: 'blur' },
  ],
  core: [
    { required: true, message: '请选择资源需求', trigger: 'blur' },
  ],
  digitize: [
    { required: true, message: '请选择数字化能力', trigger: 'blur' },
  ],
  userName: [
    { required: true, message: '请输入联系人', trigger: 'blur' },
  ],
  phone: [
    { required: true, message: '请输入联系电话', trigger: 'blur' },
    { length: 11, message: "手机号11位", trigger: 'blur' }
  ],
  email: [
    { required: true, message: '请输入邮件地址', trigger: 'blur' },
    { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
  ]
});

const companyClick=()=>{
  console.log(datas.value)
  formRef.value.validate((valid) => {
    if (valid) {
      axios({
        method:"post",
        url:"http://localhost:8082/official/livelihoodQuestionnaire",
        headers:{tenantId:'000000'},
        data:datas.value
      }).then((res)=>{
        if (res.data.code === 200){
          ElMessage.primary('上传成功')
          router.back();
        }else {
          ElMessage.error('上传失败，请重试')
        }
      })
    } else {
      return false;
    }
  });
}

</script>

<template>
  <div>
    <context-while>
      <el-form
          ref="formRef"
          :rules="rules"
          :model="datas"
          label-width="auto"
      >
      <context-title text="民生侧诊断问卷"></context-title>
      <CompanyTitle title="1.你的角色"/>
      <div>
        <el-form-item prop="role">
          <el-radio-group v-model="datas.role" class="flex flex-row">
            <el-radio value="1" size="large">社区创业者</el-radio>
            <el-radio value="2" size="large">灵活就业者</el-radio>
            <el-radio value="3" size="large">技能培训者</el-radio>
          </el-radio-group>
        </el-form-item>

        <CompanyTitle title="2.核心资源需求(可多选)"/>
        <el-form-item prop="core">
          <el-checkbox-group v-model="datas.core">
            <el-checkbox label="启动资金" value="1"/>
            <el-checkbox label="场地支持" value="2"/>
            <el-checkbox label="技能认证" value="3"/>
            <el-checkbox label="订单资源" value="4"/>
            <el-checkbox label="政策解读" value="5"/>
            <el-checkbox label="设备工具" value="6"/>
            <el-checkbox label="品牌背书" value="7"/>
          </el-checkbox-group>
        </el-form-item>


        <CompanyTitle title="3.数字化能力"/>
        <el-form-item prop="digitize">
          <el-checkbox-group v-model="datas.digitize">
            <el-checkbox label="熟练使用智能手机" value="1"/>
            <el-checkbox label="需线下辅助" value="2"/>
            <el-checkbox label="解决线上操作" value="3"/>
          </el-checkbox-group>
        </el-form-item>

      </div>
      <div class="w-full bg-[#161981] h-[0.1rem] px-24"></div>
      <div class="lg:flex lg:justify-between">
        <div class="w-full flex items-center  mt-3 md:mt-3 lg:mt-5">
          <div class="text-2xl md:text-2xl lg:text-3xl">联系人：</div>
          <div class="w-1/2  lg:mt-3">
            <el-form-item prop="userName">
              <el-input
                  v-model="datas.userName"
                  autosize
                  type="textarea"
                  :style="{
                '--el-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-focus-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-focus-border-width': '0px',
                '--el-input-hover-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-hover-border-width': '0px',
              }"
                  class="border-b-[1px]  border-black w-full"
              />
            </el-form-item>

          </div>
        </div>

        <div class="w-full flex items-center  mt-3 md:mt-3 lg:mt-5">
          <div class="text-2xl md:text-2xl lg:text-3xl">联系电话：</div>
          <div class="w-1/2   lg:mt-3">
            <el-form-item prop="phone">
              <el-input
                  v-model="datas.phone"
                  autosize
                  type="textarea"
                  :style="{
                '--el-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-focus-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-focus-border-width': '0px',
                '--el-input-hover-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-hover-border-width': '0px',
              }"
                  class="border-b-[1px]  border-black w-full"
              />
            </el-form-item>

          </div>
        </div>
      </div>
      <div class="w-full flex items-center  mt-3 md:mt-3 lg:mt-5">
        <div class="text-2xl md:text-2xl lg:text-3xl">邮件地址：</div>
        <div class="w-2/3   lg:mt-3">
          <el-form-item prop="email">
            <el-input
                autosize
                v-model="datas.email"
                type="textarea"
                :style="{
                '--el-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-focus-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-focus-border-width': '0px',
                '--el-input-hover-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-hover-border-width': '0px',
              }"
                class="border-b-[1px]  border-black w-full"
            />
          </el-form-item>
        </div>
      </div>
      <sub-button @click="companyClick"></sub-button>
      </el-form>
    </context-while>

  </div>
</template>

<style scoped>
</style>
